<template>
  <footer>
    <p class="footer-text">© 2013–2018, Cryptopay</p>
  </footer>
</template>

<script>
  export default {
    name: 'Footer'
  };
</script>

<style scoped>
@import "../styles/colors.css";
@import "../styles/consts.css";

.footer-text {
  @include proxima_regular;
  font-size: 14px;
  line-height: 1.71;
  letter-spacing: normal;
  text-align: center;
  color: $pastel-gray;
  margin: 75px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue